"use client";

import { Button } from "@decibeltrade/web-core/components";
import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { openWalletSelectorModal } from "@/components/modal/wallet-selector-modal";

import { HeadBanner } from "./banner/head-banner";
import { LifetimeEarnedCard } from "./banner/lifetime-earned-card";
import { ReadyToClaimCard } from "./banner/ready-to-claim-card";
import { WeeklyTrendCard } from "./banner/weekly-trend-card";
import { YtdCard } from "./banner/ytd-card";

export function ConnectGate() {
  const t = useTranslations("rewards.connect");

  return (
    <div className={stack({ gap: "32" })}>
      <HeadBanner
        lifetimeSlot={<LifetimeEarnedCard totalEarnedUsd={0} totalClaimedUsd={0} breakdown={[]} />}
        readyToClaimSlot={<ReadyToClaimCard count={0} totalUsd={0} onClaimAll={() => undefined} />}
        ytdSlot={<YtdCard yearToDateUsd={0} weeklyWowPct={undefined} />}
        weeklyTrendSlot={<WeeklyTrendCard weeklyBreakdown={undefined} />}
      />
      <div className={ctaStackStyles}>
        <h2 className={titleStyles}>{t("title")}</h2>
        <p className={descriptionStyles}>{t("description")}</p>
        <Button
          variant="primary"
          size="md"
          onClick={openWalletSelectorModal}
          className={ctaButtonStyles}
        >
          {t("cta")}
        </Button>
      </div>
    </div>
  );
}

const ctaStackStyles = stack({
  gap: "14",
  alignItems: "center",
  pt: { base: "32", desktop: "80" },
  pb: "32",
  textAlign: "center",
});

const titleStyles = css({ textStyle: "subheading.md", color: "text.primary" });

const descriptionStyles = css({
  textStyle: "body.lg",
  color: "text.tertiary",
  maxW: "320",
});

const ctaButtonStyles = css({ mt: "12" });
